import { render, staticRenderFns } from "./SupervisorDetailDialog.vue?vue&type=template&id=736a5c25&scoped=true&"
import script from "./SupervisorDetailDialog.vue?vue&type=script&lang=js&"
export * from "./SupervisorDetailDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736a5c25",
  null
  
)

export default component.exports